import React, { useState, useEffect } from 'react'
import { PiUserCirclePlusFill, PiGitBranchBold } from "react-icons/pi"
import { RiFileList3Fill } from "react-icons/ri";
import { FaUserLarge } from "react-icons/fa6";
import { FaBoxes } from "react-icons/fa";
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../component/loader/Loader';
import { dashboardSOListRes, dashboardSOListTodo } from '../../redux/Slices/DashboardSlice/DashboardSalesOrderList';
import { approvalTodo } from '../../redux/Slices/DashboardSlice/ApprovalPending';
import { pendingDispatchTodo } from '../../redux/Slices/DashboardSlice/PendingDispatch';
import { soTotlaTodo } from '../../redux/Slices/DashboardSlice/SOTotal';
import SalesPurchaseGraph from './SalesPurchaseGraph';
import DashboardSalesOrder from './DashboardSalesOrder';
import { SalesGraphTodo } from '../../redux/Slices/DashboardSlice/SalesPurchaseGraph';
import { DueAmtByDaysTodo } from '../../redux/Slices/DashboardSlice/DueAmtByDays';
import { DashboardLastOrderTodo } from '../../redux/Slices/DashboardSlice/DashboadLastOrder';
import TargetGraph from './TargetGraph';
import YearSalesGraph from './YearSalesGraph';
import { SalesYearMonthWiseTodo } from '../../redux/Slices/DashboardSlice/SalesYearMonthWise';
import GaugeChart from './ApexChart';
import { QuaterlyTargetOneTodo } from '../../redux/Slices/DashboardSlice/QuaterlyTargetOne';
import { QuaterlyTargetTwoTodo } from '../../redux/Slices/DashboardSlice/QuaterlyTargetTwo';
import { QuaterlyTargetThreeTodo } from '../../redux/Slices/DashboardSlice/QuaterlyTargetThree';
import { QuaterlyTargetFourTodo } from '../../redux/Slices/DashboardSlice/QuaterlyTargetFour';
import { Link } from 'react-router-dom';

export default function Dashboard() {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const dashboardData = useSelector(state => state?.Dashboard?.data?.data[0])
    const dashboard_so_list = useSelector(state => state?.DashboardSalesOrderList?.data?.list)
    const approval_data = useSelector(state => state?.ApprovalPending?.data?.pending_so)
    const so_total_data = useSelector(state => state?.SOTotal?.data?.total_So)
    const dispatch_data = useSelector(state => state?.PendingDispatch?.data?.pending_despatch)
    const salesGraphData = useSelector(state => state?.SalesPurchaseGraph?.data)
    const dueAmtDays = useSelector(state => state?.DueAmtByDays?.data)
    const lastOrder = useSelector(state => state?.DashboardLastOrder?.data?.list?.[0])
    const yearMonthSales = useSelector(state => state?.SalesMonthYearWise?.data?.data)
    const QuaterlyTargetOne = useSelector(state => state?.QuaterlyTargetOne?.data?.data)
    const QuaterlyTargetTwo = useSelector(state => state?.QuaterlyTargetTwo?.data?.data)
    const QuaterlyTargetThree = useSelector(state => state?.QuaterlyTargetThree?.data?.data)
    const QuaterlyTargetFour = useSelector(state => state?.QuaterlyTargetFour?.data?.data)
    // console.log("approval_data", approval_data)
    // console.log("so_total_data", so_total_data)
    // console.log("QuaterlyTargetOne", QuaterlyTargetOne)

    var type = localStorage.getItem('type')

    // const dashxboardFun = () => {
    //     if (dashboardSOListRes && dashboardSOListRes.success) {
    //         dispatch(approvalTodo()).then((approval_res) => {
    //             if (approval_res?.payload?.success) {
    //                 dispatch(pendingDispatchTodo()).then((pending_res) => {
    //                     if (pending_res?.payload?.success) {
    //                         dispatch(soTotlaTodo()).then((so_total_res) => {
    //                             if (so_total_res?.payload?.success) {
    //                                 // dispatch(SalesGraphTodo()).then((graph_res) => {
    //                                 //     if (graph_res?.payload?.status) {
    //                                 dispatch(DueAmtByDaysTodo()).then((dueAmt_res) => {
    //                                     if (dueAmt_res?.payload?.status) {
    //                                         dispatch(DashboardLastOrderTodo()).then((last_order_res) => {
    //                                             if (last_order_res?.payload?.status) {
    //                                                 // dispatch(SalesYearMonthWiseTodo()).then((year_month_sales) => {
    //                                                 //     if (year_month_sales?.payload?.status) {
    //                                                 //         setLoading(false)
    //                                                 //     } else {
    //                                                 //         setLoading(false)
    //                                                 //     }
    //                                                 // })
    //                                                 setLoading(false)

    //                                             } else {
    //                                                 setLoading(false)
    //                                             }
    //                                         })
    //                                     } else {
    //                                         setLoading(false)
    //                                     }
    //                                 })
    //                                 //     } else {
    //                                 //         setLoading(false)
    //                                 //     }
    //                                 // })
    //                             } else {
    //                                 setLoading(false)
    //                             }
    //                         })
    //                     } else {
    //                         setLoading(false)
    //                     }
    //                 })
    //             } else {
    //                 setLoading(false)
    //             }
    //         })

    //     } else {
    //         setLoading(false);
    //         alert('SOMETHING WENT WRONG FROM API ')

    //     }
    // }

    // dispatch(QuaterlyTargetOneTodo()).then((target_one_res) => {
    //     if (target_one_res?.payload?.status) {
    //         dispatch(QuaterlyTargetTwoTodo()).then((target_two_res) => {
    //             if (target_two_res?.payload?.status) {
    //                 dispatch(QuaterlyTargetThreeTodo()).then((target_three_res) => {
    //                     if (target_three_res?.payload?.status) {
    //                         dispatch(QuaterlyTargetFourTodo()).then((target_four_res) => {
    //                             if (target_four_res?.payload?.status) {
    //                                 setLoading(false)
    //                             } else {
    //                                 setLoading(false)
    //                             }
    //                         })
    //                     } else {
    //                         setLoading(false)
    //                     }
    //                 })
    //             } else {
    //                 setLoading(false)
    //             }
    //         })
    //     } else {
    //         setLoading(false)
    //     }
    // })


    const dashboardFun = async (res) => {
        try {
            if (dashboardSOListRes.success) {
                await Promise.all([
                    dispatch(approvalTodo()),
                    dispatch(pendingDispatchTodo()),
                    dispatch(soTotlaTodo()),
                    dispatch(DueAmtByDaysTodo()),
                    dispatch(DashboardLastOrderTodo()),
               
                ]);
                setLoading(false)
            } else {
                setLoading(false)
            }
        } catch (error) {
            // console.error(error)
            setLoading(false)
        }
    }



    useEffect(() => {
        setLoading(true)
        dispatch(dashboardSOListTodo()).then(() => dashboardFun())
    }, [])


    return (
        <>
            <div className="container-fluid">
                <div className='layout_head'>
                    <h5> Dashboard </h5>
                </div>
                {loading ?
                    <div className='d-flex justify-content-center mt-5 pt-5'>
                        <Loader />
                    </div> :
                    <div className="row">

                        <div className="col-md-4 mt-3">
                            <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Outstanding</h4>
                                        <h3 className='text-center'>{localStorage.getItem('fopening_balance')}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-3 mt-3">
                            <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Credit Limit</h4>
                                        <h3 className='text-center'>{localStorage.getItem('fcredit_limit')}</h3>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-md-4 mt-3">
                        <Link to='/approval-pending-order'>   <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Sales Order <br /> Approval Pending</h4>
                                        <h3 className='text-center'>{approval_data}</h3>
                                    </div>
                                </div>
                            </div></Link> 
                        </div>
                        <div className="col-md-4 mt-3">
                         <Link to='/sales-order-list'> 
                           <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Total Order</h4>
                                        <h3 className='text-center'>{so_total_data}</h3>
                                    </div>
                                </div>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Dispatch Pending</h4>
                                        <h3 className='text-center'>{dispatch_data}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Due Amount <br /> By {dueAmtDays?.days} Days</h4>
                                        <h3 className='text-center'>{dueAmtDays?.due_amount_by_days}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card dashboard_card text-center  h-100" >
                                <div className='d-flex justify-content-around align-items-center '>
                                    <div className=''>
                                        <span className='dashboard_icon'>
                                            < FaBoxes size={35} style={{ color: "#105684" }} />
                                        </span>
                                    </div>
                                    <div className=''>
                                        <h4>Last Order</h4>
                                        <h3 className='text-center'>{lastOrder?.dpo_date1}</h3>
                                        <p style={{ color: 'grey', fontSize: "14px", fontWeight: '600' }}>( {lastOrder?.days_before} Days Before )</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-6 mt-3">
                            <div className='chart_sec '>
                                <SalesPurchaseGraph salesGraphData={salesGraphData} />
                            </div>
                        </div> */}
                        {/* <div className="col-md-6 mt-3 ">
                            <div className='chart_sec '>
                                <div className='layout_head'>
                                    <h5>Year on Year's Sales </h5>
                                </div>
                                <YearSalesGraph data={yearMonthSales} />
                            </div>
                        </div> */}
                        {/* <div className="col-md-6 mt-3 ">
                            <div className='chart_sec content' >
                                <div className='layout_head'>
                                    <h5> Q1</h5>
                                </div>
                                <GaugeChart data={QuaterlyTargetOne} />
                            </div>
                        </div>
                        <div className="col-md-6 mt-3 ">
                            <div className='chart_sec content' >
                                <div className='layout_head'>
                                    <h5> Q2</h5>
                                </div>
                                <GaugeChart data={QuaterlyTargetTwo} />
                            </div>
                        </div>
                        <div className="col-md-6 mt-3 ">
                            <div className='chart_sec content' >
                                <div className='layout_head'>
                                    <h5> Q3</h5>
                                </div>
                                <GaugeChart data={QuaterlyTargetThree} />
                            </div>
                        </div>
                        <div className="col-md-6 mt-3 ">
                            <div className='chart_sec content' >
                                <div className='layout_head'>
                                    <h5> Q4</h5>
                                </div>
                                <GaugeChart data={QuaterlyTargetFour} />

                            </div>
                        </div> */}
                        <div className="col-md-12 mt-3">
                            <DashboardSalesOrder dashboard_so_list={dashboard_so_list} />

                        </div>


                    </div>}
            </div>
        </>
    )
}
